const ko = {
  about: {
    desc:
      "우리의 사명은 다양한 플랫폼에서 작업을 간소화하고 생산성을 향상시키는 원활하고 사용자 친화적인 무료 애플리케이션을 개발하는 것입니다. 우리는 품질이나 사용자 경험을 희생하지 않으면서 일상을 더 쉽게 만들어주는 도구를 만드는 것을 믿습니다.",
    title: "회사 소개",
    portfolio: {
      title: "포트폴리오",
      mpc: {
        name: "결혼 포인트 계산기",
        desc:
          "🃏 결혼 카드 게임을 위한 최고의 동반자: 결혼 포인트 계산기 (센터 컬렉션) 모바일 앱! 쉽고 공유 가능한 인터페이스로 더 이상 점수 계산에 어려움을 겪지 마세요.",
        playStore: "Play 스토어에서 받기",
        appStore: "App 스토어에서 받기",
        web: "웹 앱 열기",
      },
      led: {
        name: "LED & 네온 사인보드",
        desc1:
          "당신의 기기를 디지털 사인보드로 바꿔보세요. 휴대폰, 태블릿 또는 스마트 TV로 밝고 눈에 띄는 메시지를 표시하세요.",
        desc2: "콘서트 및 라이브 이벤트에 최적입니다.",
        playStore: "Play 스토어에서 받기",
        appStore: "App 스토어에서 받기",
        web: "웹 앱 열기",
      },
      tax: {
        name: "세무 상담 네팔",
        desc: "세금을 계산하고 절세 방법을 찾아보세요.",
        web: "웹 앱 열기",
      },
      installOnMobile: "설치",
      openWebApp: "웹 앱 열기",
    },
    team: {
      title: "팀 소개",
      manoj: {
        name: "마노즈 슈레스타",
        role: "최고경영자 (CEO)",
        desc:
          "10년 이상의 경험을 가진 IT 비즈니스 전문가. IT를 활용해 비즈니스 문제를 해결하는 데 뛰어난 역량을 보유하고 있습니다.",
        profile: "프로필 보기",
      },
      pujan: {
        name: "푸잔 슈레스타",
        role: "최고기술책임자 (CTO)",
        desc:
          "7년 이상의 소프트웨어 개발 경험을 가진 기술 전문가. 회사의 모든 기술적인 측면을 책임지고 있으며, 풀스택 개발자로도 활동하고 있습니다.",
        profile: "프로필 보기",
      },
      learnMore: "자세히 보기",
    },

    description:
      "저희 애플리케이션에 오신 것을 환영합니다! 최고의 경험을 제공하기 위해 노력하고 있습니다.",
  },
  share: {
    title: "공유하기",
    description: "앱을 설치하려면 친구에게 QR 코드를 스캔하라고 하세요!",
  },
  privacy: {
    title: "개인정보 처리방침",
    date: "2024년 1월 1일",
    description: "저희 앱을 이용해 주셔서 감사합니다. 귀하의 개인정보는 저희에게 매우 중요합니다. 본 개인정보 처리방침은 정보 수집, 이용, 보호 방법을 안내합니다.",
    sections: {
      1: {
        title: "수집하는 정보",
        body: "개인정보: 귀하가 자발적으로 제공하는 경우 이름, 이메일 등 연락처 정보를 수집할 수 있습니다.\n\n이용 데이터: 앱 내에서 방문한 페이지, 사용한 기능 등 이용 내역을 수집합니다.\n\n기기 정보: 성능 개선 및 문제 해결을 위해 기기 종류, 운영체제, 앱 버전을 수집할 수 있습니다."
      },
      2: {
        title: "정보의 이용 방법",
        body: "서비스 제공 및 개선을 위해.\n\n사용자 경험을 맞춤화하기 위해.\n\n문의에 응답하고 지원을 제공하기 위해.\n\n중요 공지 또는 프로모션 메시지 발송(동의 시에만)."
      },
      3: {
        title: "정보의 공유",
        body: "개인정보를 판매하지 않습니다. 다음의 경우에만 정보를 공유할 수 있습니다:\n\n앱 운영을 돕는 신뢰할 수 있는 제3자 서비스와.\n\n법적 요구 또는 권리 보호를 위해."
      },
      4: {
        title: "데이터 보안",
        body: "무단 접근, 분실, 오용으로부터 데이터를 보호하기 위해 적절한 기술적·관리적 조치를 시행합니다."
      },
      5: {
        title: "이용자의 권리",
        body: "귀하는 다음과 같은 권리가 있습니다:\n\n보유 정보 열람\n\n정정 또는 삭제 요청\n\n언제든 동의 철회"
      },
      6: {
        title: "제3자 서비스",
        body: "앱은 별도의 개인정보 처리방침을 가진 제3자 서비스(예: 분석, 광고)를 사용할 수 있습니다. 해당 정책도 확인해 주세요."
      },
      7: {
        title: "정책 변경",
        body: "본 방침은 수시로 변경될 수 있습니다. 변경 시 앱 내에 새로운 시행일과 함께 안내합니다."
      },
      8: {
        title: "문의하기",
        body: "본 정책에 대한 문의 사항이 있으시면 shrestha.applications@gmail.com 으로 연락해 주세요."
      }
    }
  },
  terms: {
    title: "이용 약관",
    description: "앱을 사용하기 전에 이 약관을 주의 깊게 읽어주세요.",
    sections: {
      1: {
        title: "이용 약관 동의",
        body:
          "이 애플리케이션에 접근하거나 사용하는 경우, 본 약관에 동의하는 것으로 간주됩니다.",
      },
      2: {
        title: "약관의 변경",
        body:
          "당사는 언제든지 본 약관을 변경, 수정 또는 개정할 권리가 있습니다. 변경 후에도 앱을 계속 사용하면 새로운 약관에 동의한 것으로 간주됩니다.",
      },
      3: {
        title: "사용자의 책임",
        body:
          "사용자는 앱을 합법적인 목적으로만 사용하며, 앱 또는 다른 사용자에게 해를 끼치는 행위를 하지 않을 것에 동의합니다.",
      },
      4: {
        title: "지적 재산권",
        body:
          "이 앱의 모든 콘텐츠, 기능 및 기능성은 Shrestha Apps의 독점 재산이며 저작권 및 기타 법률에 의해 보호됩니다.",
      },
      5: {
        title: "제3자 서비스",
        body:
          "앱에는 당사가 소유하거나 관리하지 않는 제3자 웹사이트 또는 서비스에 대한 링크가 포함될 수 있습니다. 당사는 제3자 사이트의 콘텐츠 또는 관행에 대해 책임지지 않습니다.",
      },
      6: {
        title: "보증의 부인",
        body:
          "앱은 '있는 그대로' 및 '이용 가능한 상태로' 제공됩니다. 당사는 앱의 운영 또는 가용성에 대해 명시적 또는 묵시적으로 어떠한 보증도 하지 않습니다.",
      },
      7: {
        title: "책임의 제한",
        body:
          "Shrestha Apps는 앱 사용과 관련하여 발생하는 어떠한 손해에 대해서도 책임을 지지 않습니다.",
      },
      8: {
        title: "면책",
        body:
          "사용자는 앱 사용으로 인해 발생하는 모든 청구, 손해 또는 비용으로부터 Shrestha Apps를 면책하는 데 동의합니다.",
      },
      9: {
        title: "이용 종료",
        body:
          "당사는 사유를 불문하고 언제든지 사전 통지 없이 사용자의 앱 접근을 중단하거나 종료할 권리가 있습니다.",
      },
      10: {
        title: "준거법",
        body: "본 약관은 네팔 법률에 따라 규율되고 해석됩니다.",
      },
      11: {
        title: "문의하기",
        body:
          "본 약관에 대해 궁금한 점이 있으시면 shresthaapps@gmail.com 으로 문의해 주세요.",
      },
      12: {
        title: "전체 계약",
        body:
          "이 약관은 앱 사용과 관련하여 귀하와 Shrestha Apps 간의 전체 계약을 구성합니다.",
      },
    },
    title: "이용 약관",
    description: "앱 사용 전에 이용 약관을 꼭 읽어주세요.",
  },
  footer: {
    copyright: "© {year} Shrestha Apps",
    allRightsReserved: "모든 권리 보유",
    tagline: "삶을 더 편리하게 만드는 앱을 개발합니다.",
    nepal: "네팔",
    japan: "일본",
    usa: "미국",
    email: "이메일",
  },
};

export default ko;
